import { useCallback, useState } from 'react';
import { batchesAPI } from '../services/api';
import { normalizeApiListResponse } from '../utils/apiListNormalize';

/**
 * Loads and normalizes batches for modals (SRP: batch list fetching for UI).
 */
export function useLoadBatches() {
  const [batches, setBatches] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadBatches = useCallback(async () => {
    setLoading(true);
    try {
      const res = await batchesAPI.getAll();
      setBatches(normalizeApiListResponse(res.data));
    } catch (e) {
      console.error('Failed to load batches:', e);
      setBatches([]);
    } finally {
      setLoading(false);
    }
  }, []);

  return { batches, loading, loadBatches };
}
